module.exports = __webpack_public_path__ + "static/media/nabcep-certified.e47e64db.png";